const CAP22 = {
  "id": 45,
  "title": "Cómo conseguir Bitcoin",
  "slug": "como-conseguir-bitcoin",
  "type": "lesson",
  "category": "bitcoin",
  "level": "basic",
  "sections": [
    {
      "heading": "Introducción",
      "text": [
        "Para empezar a manejar tus primeros bitcoin, únicamente necesitas una cartera o monedero (wallet) y recibir en ella cualquier cantidad de la criptomoneda.",
        "Existen diferentes formas de obtener Bitcoin, algunas requieren conocimientos técnicos y otras son muy simples, accesibles para cualquier persona."
      ]
    },
    {
      "heading": "Formas más comunes de conseguir Bitcoin",
      "list": [
        "📦 Comprar Bitcoin en una casa de cambio o exchange.",
        "💻 Hacer minería de Bitcoin y recibir recompensas por validar transacciones.",
        "🛒 Aceptar Bitcoin como medio de pago por productos o servicios.",
        "🔄 Recibir Bitcoin de otra persona como transferencia directa.",
        "🎁 Ganarlo mediante recompensas, programas educativos o ‘faucets’."
      ]
    },
    {
      "heading": "Compra de Bitcoin (el método más usado)",
      "text": [
        "La forma más sencilla y utilizada para conseguir Bitcoin es comprarlo mediante una plataforma de intercambio (exchange).",
        "Estos servicios permiten comprar Bitcoin utilizando dinero tradicional (fiat) como euros, dólares, pesos, etc.",
        "Los métodos de pago más habituales incluyen transferencia bancaria, tarjeta de crédito o débito, y sistemas de pago móviles."
      ]
    },
    {
      "heading": "Minería de Bitcoin",
      "text": [
        "La minería consiste en usar dispositivos especializados para verificar transacciones y asegurar la red.",
        "Los mineros reciben Bitcoin como recompensa por su trabajo.",
        "Hoy en día, la minería requiere equipos costosos y gran consumo eléctrico, por lo que no siempre es accesible para todos."
      ]
    },
    {
      "heading": "Pago por productos y servicios",
      "text": [
        "Otra forma de obtener Bitcoin es recibirlo como pago por tu trabajo, productos o servicios.",
        "Cada vez más profesionales, comercios, freelancers y creadores aceptan Bitcoin como forma de pago."
      ]
    },
    {
      "heading": "Recibir Bitcoin desde otra wallet",
      "text": [
        "Puedes recibir Bitcoin de un amigo, familiar o cualquier persona que ya tenga BTC.",
        "Solo necesitas compartir tu dirección pública (tu ‘número de cuenta’ de Bitcoin) o mostrar el código QR.",
        "Una vez enviada la transacción, podrás ver su progreso y confirmaciones desde cualquier explorador de bloques."
      ]
    },
    {
      "heading": "¿Qué necesitas para empezar?",
      "list": [
        "Tener una wallet (cartera) para recibir tus bitcoins.",
        "Obtener una dirección pública.",
        "Elegir cómo quieres conseguir tus primeros satoshis: compra, minería, pago o transferencia."
      ]
    },
    {
      "heading": "¿Y ahora qué sigue?",
      "text": [
        "En la clase práctica aprenderás cómo realizar tus primeras transacciones, cómo comprar, enviar y recibir Bitcoin de forma segura.",
        "Verás paso a paso cómo usar tu monedero, cómo copiar direcciones, cómo consultar el historial y cómo verificar transacciones en la blockchain."
      ]
    },
    {
      "heading": "Resumen rápido",
      "list": [
        "Puedes obtener Bitcoin comprándolo, minándolo, recibiéndolo como pago u obteniéndolo de otra persona.",
        "Solo necesitas una wallet y una dirección pública para recibir cualquier cantidad.",
        "Bitcoin es divisible hasta en satoshis, por lo que puedes empezar con cantidades pequeñas."
      ]
    }
  ]
};

export default CAP22;
